<template>
  <b-alert variant="success" show>
    <h3 class="mb-3">
      <b-icon class="me-2" icon="trophy"></b-icon>
      <sapn class="small ml-2">
        Dieses Projekt
        <b>&raquo;{{ ProjectStore.activeProject.Name }}&laquo;</b>
        ist beendet.
      </sapn>
    </h3>
    Dieses Projekt wurde beendet und steht nicht länger zur Verfügung.
    <div class="mt-4 mb-3">
      <b-button href="/">
        Zurück zu BauVisor
      </b-button>
    </div>
  </b-alert>
</template>

<script>
import AppState from '@/store/App.js';
import ProjectStore from '@/store/Projects';
export default {
  data() {
    return {
      AppState,
      ProjectStore
    };
  },
  activated() {
    AppState.isLoading = false;
    AppState.showNav = false;
  }
};
</script>

<style></style>
